import Icon from '../components/Icon.vue'

Icon.register({
  'window-close': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM380.4 322.5C385.2 327.3 385.2 335.1 380.4 339.9L339.9 380.4C335.1 385.2 327.3 385.2 322.5 380.4L256 313.3 189.5 380.4C184.7 385.2 176.9 385.2 172.1 380.4L131.6 339.9C126.8 335.1 126.8 327.3 131.6 322.5L198.7 256 131.6 189.5C126.8 184.7 126.8 176.9 131.6 172.1L172.1 131.6C176.9 126.8 184.7 126.8 189.5 131.6L256 198.7 322.5 131.6C327.3 126.8 335.1 126.8 339.9 131.6L380.4 172.1C385.2 176.9 385.2 184.7 380.4 189.5L313.3 256 380.4 322.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/window-close.js
// module id = LwaB
// module chunks = 144